import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { OrganismFrame } from '@/core/architecture'

export const ConsoleEventItemSkeleton = () => (
  <OrganismFrame>
    <Card elevation={0}>
      <CardContent sx={{ py: 2, px: 4, '&:last-child': { pb: 2 } }}>
        <Stack direction="row" spacing={4}>
          <Skeleton variant="rectangular" sx={{ height: 70, width: 100 }} />
          <Stack flex={1} spacing={1} sx={{ minWidth: 0 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <SkeletonText variant="medium" width="20%" />
              <SkeletonText variant="medium" width="60%" />
            </Stack>
            <SkeletonText variant="medium" numberOfLine={2} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  </OrganismFrame>
)
